import { RoleFunction } from '@eagle/common';
import { PortalIcons } from '../components/icons/portal';
import { Portal } from '../types';

export const portalDefinitions: Record<Portal, {
  label: string;
  icon: typeof PortalIcons.Tracking;
  roleFunction: RoleFunction[];
  path: string;
}> = {
  track: {
    label: 'common:common.labels.track',
    icon: PortalIcons.Tracking,
    roleFunction: [RoleFunction.DATA_VIEWER],
    path: '/track',
  },
  manage: {
    label: 'common:common.labels.manage',
    icon: PortalIcons.Management,
    roleFunction: [RoleFunction.INSTALLER, RoleFunction.SYSTEM_ADMINISTRATOR],
    path: '/manage',
  },
  admin: {
    label: 'common:common.labels.admin',
    icon: PortalIcons.Administration,
    roleFunction: [RoleFunction.ADMINISTRATOR],
    path: '/admin',
  },
};

type HasAuthorization = (roles: readonly string[]) => boolean

export const hasPortalAccess = (portal: Portal, hasAuthorization: HasAuthorization): boolean => {
  return hasAuthorization(portalDefinitions[portal].roleFunction);
};

export const getAccessiblePortals = (hasAuthorization: HasAuthorization): Portal[] => {
  const portals: Portal[] = ['track', 'manage', 'admin'];
  return portals.filter((portal) => hasPortalAccess(portal, hasAuthorization));
};
